export enum risk_type {
  All = 0,
  virus = 1,
  vulnerability = 2,
  port = 3,
  baseline = 4,
  blackmail = 5,
  weak_mouth = 6,
  separated = 7,
}

export enum isolation_status {
  disSeparated = 2,
  separated = 1,
  unknown_info = 0,
  dispatching = 3,
  fail = 4,
  recovering = 5,
  recoverFail = 6,
}
export const status_label_color = {
  [isolation_status.separated]: 'var(--el-color-danger)',
  [isolation_status.disSeparated]: '',
  [isolation_status.unknown_info]: '',
}
export enum login_status {
  online = 1,
  offline = 2
}

// 弱密码类型枚举（对应 C++ 的 WeakPasswordType）
export enum WeakPasswordType {
  NONE = 0,
  EMPTY = 1 << 0,              // 1 - 空密码
  CONTAINS_USERNAME = 1 << 1,  // 2 - 包含用户名
  DICTIONARY_COMMON = 1 << 2, // 4 - 全球常见弱密码：123456, password, admin
  SHORT_PASSWORD = 1 << 3,     // 8 - 长度 < 8
  PURE_NUMBER = 1 << 4,        // 16 - <= 8 位纯数字
  PURE_ALPHA = 1 << 5,         // 32 - <= 8 位纯字母
  ALNUM_SIMPLE = 1 << 6,       // 64 - <= 6~8 混合但简单，例如 abc123
  KEYBOARD_SEQ = 1 << 7,       // 128 - qwerty, 1q2w3ed
}

/** responseHandle 下的 i18n 键名（不含命名空间前缀） */
export const WEAK_PASSWORD_TYPE_I18N_KEY: Partial<Record<WeakPasswordType, string>> = {
  [WeakPasswordType.EMPTY]: 'weakPasswordTypeEmpty',
  [WeakPasswordType.CONTAINS_USERNAME]: 'weakPasswordTypeContainsUsername',
  [WeakPasswordType.DICTIONARY_COMMON]: 'weakPasswordTypeDictionaryCommon',
  [WeakPasswordType.SHORT_PASSWORD]: 'weakPasswordTypeShortPassword',
  [WeakPasswordType.PURE_NUMBER]: 'weakPasswordTypePureNumber',
  [WeakPasswordType.PURE_ALPHA]: 'weakPasswordTypePureAlpha',
  [WeakPasswordType.ALNUM_SIMPLE]: 'weakPasswordTypeAlnumSimple',
  [WeakPasswordType.KEYBOARD_SEQ]: 'weakPasswordTypeKeyboardSeq',
}

// 解析弱密码类型位标志值，返回所有匹配的类型
export const parseWeakPasswordTypes = (value: number | string | null | undefined): WeakPasswordType[] => {
  if (!value || value === 0) {
    return []
  }

  const numValue = typeof value === 'string' ? parseInt(value, 10) : value
  if (isNaN(numValue) || numValue === 0) {
    return []
  }

  const types: WeakPasswordType[] = []

  // 检查每个位标志
  Object.values(WeakPasswordType).forEach((type) => {
    if (typeof type === 'number' && type !== WeakPasswordType.NONE) {
      // 使用位运算检查该标志是否被设置
      if ((numValue & type) === type) {
        types.push(type)
      }
    }
  })

  return types
}
